/**
 * Servicio de geolocalización del usuario.
 * Intenta usar ipapi.co primero. Si falla, usa ipquery.io como respaldo.
 */
export const getUserGeoData = async () => {
    // INTENTO 1: Usar ipapi.co
    try {
        const response = await fetch('https://ipapi.co/json/');
        if (!response.ok) {
            throw new Error(`ipapi.co error: ${response.status}`);
        }
        const data = await response.json();
        return {
            ip: data.ip || 'unknown',
            country: data.country_name || 'unknown',
            region: data.region || 'unknown',
        };
    } catch (error) {
        console.warn(`Intento 1 falló (${error.message}). Probando Plan B...`);

        // INTENTO 2 (Fallback): Usar ipquery.io
        try {
            // Pasamos format=json para asegurar la respuesta correcta
            const responseBackup = await fetch('https://api.ipquery.io/?format=json');
            if (!responseBackup.ok) {
                throw new Error(`ipquery.io error: ${responseBackup.status}`);
            }
            const dataBackup = await responseBackup.json();

            // ipquery devuelve los datos con una estructura ligeramente distinta
            return {
                ip: dataBackup.ip || 'unknown',
                country: dataBackup.location?.country || 'unknown',
                region: dataBackup.location?.state || 'unknown',
            };
        } catch (backupError) {
            // Si ambos fallan (ej. el usuario no tiene internet)
            console.error('Ambas APIs de geolocalización fallaron:', backupError.message);
            return {
                ip: 'unknown',
                country: 'unknown',
                region: 'unknown',
            };
        }
    }
};